// KeyboardEngine.js

// ==========================================
// 1. COMPREHENSIVE MULTI-LAYOUT DICTIONARY MAPS
// ==========================================
export const KEY_MAPS = {
  inscript: {
    // Lowercase / Base Layer
    'q': 'ौ', 'w': 'ै', 'e': 'ा', 'r': 'ी', 't': 'ू', 'y': 'ब', 'u': 'ह', 'i': 'ग', 'o': 'द', 'p': 'ज', '[': 'ड', ']': '़',
    'a': 'ो', 's': 'े', 'd': '्', 'f': 'ि', 'g': 'ु', 'h': 'प', 'j': 'र', 'k': 'क', 'l': 'त', ';': 'च', "'": 'ट',
    'z': 'ॆ', 'x': 'ं', 'c': 'म', 'v': 'न', 'b': 'व', 'n': 'ल', 'm': 'स', ',': ',', '.': '।', '/': 'य',
    
    // Shift-Modified Layer
    'Q': 'औ', 'W': 'ऐ', 'E': 'आ', 'R': 'ई', 'T': 'ऊ', 'Y': 'भ', 'U': 'ङ', 'I': 'घ', 'O': 'ध', 'P': 'झ', '{': 'ढ', '}': 'ञ',
    'A': 'ओ', 'S': 'ए', 'D': 'अ', 'F': 'इ', 'G': 'उ', 'H': 'फ', 'J': 'ऱ', 'K': 'ख', 'L': 'थ', ':': 'छ', '"': 'ठ',
    'Z': 'ऑ', 'X': 'ँ', 'C': 'ण', 'V': 'ऩ', 'B': 'ळ', 'N': 'ळ', 'M': 'श', '<': 'ष', '>': 'ऽ', '?': 'य़'
  },
  
  remington_gail: {
    // Lowercase / Base Layer
    'q': 'ु', 'w': 'ू', 'e': 'म', 'r': 'त', 't': 'ज', 'y': 'ल', 'u': 'न', 'i': 'प', 'o': 'व', 'p': 'च', '[': 'ख', ']': ',',
    'a': 'ं', 's': 'े', 'd': 'क', 'f': 'ि', 'g': 'ह', 'h': 'ी', 'j': 'र', 'k': 'ा', 'l': 'स', ';': 'य', "'": 'श',
    'z': '्र', 'x': 'ग', 'c': 'ब', 'v': 'अ', 'b': 'इ', 'n': 'द', 'm': 'उ', ',': 'ए', '.': 'ण्', '/': 'ध',
    
    // Shift-Modified Layer
    'Q': 'फ', 'W': 'ॅ', 'E': 'म्', 'R': 'त्', 'T': 'ज्', 'Y': 'ल्', 'U': 'न्', 'I': 'प्', 'O': 'व्', 'P': 'च्', '{': 'क्ष', '}': 'द्व',
    'A': 'ँ', 'S': 'ै', 'D': 'क्', 'F': 'थ', 'G': 'ळ', 'H': 'भ', 'J': 'श्र', 'K': 'ज्ञ', 'L': 'स्', ':': 'रू', '"': 'ष',
    'Z': 'र्', 'X': 'ग्', 'C': 'ब्', 'V': 'ट', 'B': 'ठ', 'N': 'छ', 'M': 'ड', '<': 'ढ', '>': 'झ', '?': 'घ'
  },

  remington_cbi: {
    // CBI shares the standard keys with GAIL
    'q': 'ु', 'w': 'ू', 'e': 'म', 'r': 'त', 't': 'ज', 'y': 'ल', 'u': 'न', 'i': 'प', 'o': 'व', 'p': 'च', '[': 'ख', ']': ',',
    'a': 'ं', 's': 'े', 'd': 'क', 'f': 'ि', 'g': 'ह', 'h': 'ी', 'j': 'र', 'k': 'ा', 'l': 'स', ';': 'य', "'": 'श',
    'z': '्र', 'x': 'ग', 'c': 'ब', 'v': 'अ', 'b': 'इ', 'n': 'द', 'm': 'उ', ',': 'ए', '.': 'ण्', '/': 'ध',
    
    'Q': 'फ', 'W': 'ॅ', 'E': 'म्', 'R': 'त्', 'T': 'ज्', 'Y': 'ल्', 'U': 'न्', 'I': 'प्', 'O': 'व्', 'P': 'च्', '{': 'क्ष', '}': 'द्व',
    'A': 'ँ', 'S': 'ै', 'D': 'क्', 'F': 'थ', 'G': 'ळ', 'H': 'भ', 'J': 'श्र', 'K': 'ज्ञ', 'L': 'स्', ':': 'रू', '"': 'ष',
    'Z': 'र्', 'X': 'ग्', 'C': 'ब्', 'V': 'ट', 'B': 'ठ', 'N': 'छ', 'M': 'ड', '<': 'ढ', '>': 'झ', '?': 'घ'
  }
};

// ==========================================
// 2. THE TRANSLATION LOGIC ENGINE
// ==========================================
let pendingRemingtonMatra = '';

export const translateKeystroke = (eventKey, activeLayout) => {
  if (activeLayout === 'english' || activeLayout === 'kruti_dev') {
    return eventKey; 
  }

  const map = KEY_MAPS[activeLayout];
  if (!map) return eventKey;

  if (activeLayout === 'inscript' || activeLayout === 'remington_cbi') {
    return map[eventKey] || eventKey; 
  }

  if (activeLayout === 'remington_gail') {
    if (eventKey === 'f') {
      pendingRemingtonMatra = 'ि';
      return ''; 
    }

    let mappedChar = map[eventKey] || eventKey;

    if (pendingRemingtonMatra && mappedChar.trim() !== '') {
      let combinedCharacter = mappedChar + pendingRemingtonMatra;
      pendingRemingtonMatra = ''; 
      return combinedCharacter;
    }

    return mappedChar;
  }

  return eventKey;
};

// ==========================================
// 3. HIGH-PRECISION REVERSE LOOKUP MAPPER
// ==========================================
export const getReverseKeyMap = (targetChar, layout) => {
  if (layout === 'english' || layout === 'kruti_dev') {
    const shiftSymbols = {'~':'`', '!':'1', '@':'2', '#':'3', '$':'4', '%':'5', '^':'6', '&':'7', '*':'8', '(':'9', ')':'0', '_':'-', '+':'=', '{':'[', '}':']', '|':'\\', ':':';', '"':"'", '<':',', '>':'.', '?':'/'};
    const isUpper = targetChar.match(/[A-Z]/) || shiftSymbols[targetChar];
    return {
      physicalKey: (shiftSymbols[targetChar] || targetChar).toLowerCase(),
      needsShift: !!isUpper
    };
  }

  const map = KEY_MAPS[layout];
  if (!map) return { physicalKey: targetChar.toLowerCase(), needsShift: false };

  for (const [engKey, hindiChar] of Object.entries(map)) {
    if (hindiChar === targetChar) {
       const isShiftKey = engKey.match(/[A-Z]/) || ['~','!','@','#','$','%','^','&','*','(',')','_','+','{','}','|',':','"','<','>','?'].includes(engKey);
       return {
         physicalKey: engKey.toLowerCase(),
         needsShift: !!isShiftKey
       };
    }
  }

  return { physicalKey: targetChar.toLowerCase(), needsShift: false };
};